import React from 'react'

import { Tag, Button, Popconfirm } from 'antd'
import { Link } from 'react-router-dom'
import { LAYOUT_ADMIN_MANAGER_EDIT } from '../../navigation'
import { basicDeleteActionField } from '../../../../components/table/fields/common'
import { configureField } from '../../../../core/utils/list'

const confirmationMessage = 'Are you sure?'

export const basicColumns = (props) => {
  const { toggle, remove, loading, filters, resize, hidden, actionLoading } = props

  if (loading) return []

  return [
    {
      title: 'Name',
      dataIndex: 'name',
      fixed: 'left',
      render: (name, record) => <Link to={LAYOUT_ADMIN_MANAGER_EDIT(record.id)}>{name}</Link>,
      ...configureField('m.name', filters, resize, hidden, true, true, false, 200)
    },
    {
      title: 'EMail',
      dataIndex: 'email',
      ellipsis: true,

      ...configureField('m.email', filters, resize, hidden, true, false, true, 200)
    },
    {
      title: 'Skype',
      dataIndex: 'skype',
      ellipsis: true,

      ...configureField('m.skype', filters, resize, hidden, true, false, true, 200)
    },

    {
      title: 'Has Access',
      dataIndex: 'user',
      render: (user, record) => {
        if (!user) {
          return <>NO</>
        }

        if (user && (user.status === 'ACTIVE')) {
          return <>YES</>
        }

        if (user && (user.status === 'INACTIVE')) {
          return <>NO</>
        }

        return (
          <>
            INVITED
            <Popconfirm
              title={confirmationMessage}
              onConfirm={() => props.invite(record.id)}
              okText='Yes'
              cancelText='No'
            >
              <Button size='small' type='link' disabled={props.actionLoading}>
                (Resend mail)
              </Button>
            </Popconfirm>
          </>
        )
      },
      ...configureField('u.active', filters, resize, hidden, true, false, true, 200),
    },
    {
      title: 'Status',
      dataIndex: 'active',
      width: 200,
      render: (check, record) => (
        <>{check ? <Tag color='green'> ENABLED </Tag> : <Tag color='volcano'> DISABLED </Tag>}</>
      ),
      ...configureField('m.active', filters, resize, hidden, true, false, true, 200)
    },
    {
      ...basicDeleteActionField({ toggle, remove, loading: actionLoading }),
      visible: true
    }
  ]
}
